import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Grid, Button } from 'semantic-ui-react';
import ToggleDisplay from 'react-toggle-display';

import { NoticeList, NoticeAdd, NoticeDtl } from 'components/CompanyNotice';

import * as com_action from 'actions/company';
import cm from 'helpers/commons';

class CompanyNotice extends Component {
  constructor(props) {
    super(props);

    this.state = {
      page: 1,
      pagerow: 15,

      list: true,
      add: false,
      detail: false
    };
  }

  componentDidMount() {
    cm.mainTitle('회사 공지사항');
  }

  shouldComponentUpdate(nextProps, nextState) {
    return this.state !== nextState;
  }

  moveToList = async () => {
    this.setState({
      list: true,
      add: false,
      detail: false
    });

    await this.noticeList();
  };

  moveToRegister = () => {
    this.setState({
      list: false,
      add: true,
      detail: false
    });
  };

  moveToDetail = (id) => {
    this.setState({
      list: false,
      add: false,
      detail: true
    });

    this.noticeDetail(id);
  };

  //목록
  noticeList = async () => {
    const { comAPI } = this.props;
    const { page, pagerow } = this.state;
    let random = Math.random() * 10000;

    const params = {
      page: page,
      pagerow: pagerow,
      random: random
    };
    try {
      await comAPI.noticeList(params);
    } catch (e) {
      let response = e.response;
      if (response) {
        toastr('top-right', 'error', response.data.message);
      }
      console.log('######  noticeList : ', e);
    } finally {
    }
  };

  //페이지
  pageClick = async (page) => {
    await this.setState({ page: page });
    this.noticeList();
  };

  //상세보기
  noticeDetail = async (id) => {
    const { comAPI } = this.props;
    await comAPI.noticeDtl(id);

    const { detail } = this.props;

    this.setState({
      list: false,
      add: false,
      detail: true
    });
  };

  render() {
    const { page, pagerow } = this.state;
    const ListFn = {
        page: page,
        pagerow: pagerow,
        noticeList: this.noticeList,
        pageClick: this.pageClick,
        moveToRegister: this.moveToRegister,
        moveToDetail: this.moveToDetail
      },
      AddFn = {
        moveToList: this.moveToList
      },
      DetailFn = {
        moveToList: this.moveToList
      };

    return (
      <main>
        <ToggleDisplay show={this.state.list}>
          <NoticeList ListFn={ListFn} />
        </ToggleDisplay>

        <ToggleDisplay show={this.state.add}>
          <NoticeAdd AddFn={AddFn} />
        </ToggleDisplay>

        <ToggleDisplay show={this.state.detail}>
          <NoticeDtl DetailFn={DetailFn} />
        </ToggleDisplay>
      </main>
    );
  }
}

CompanyNotice = connect(
  (state) => ({
    detail: state.company.detail
  }),
  (dispatch) => ({
    comAPI: bindActionCreators(
      {
        noticeList: com_action.NoticeList,
        noticeDtl: com_action.NoticeDtl
      },
      dispatch
    )
  })
)(CompanyNotice);

export default CompanyNotice;
